import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { UserProfileType } from "@/types/view";
import { UserService } from "@/services";
import { StorageUtils } from "@/utils";
import { KeyConstant } from "@/const";

const DEFAULT_USER_PROFILE: UserProfileType = {
  name: "",
  email: "",
  phoneNumber: "",
  unit: "",
  department: "",
};

export const useProfile = () => {
  const uid = StorageUtils.getItem<string>(KeyConstant.KEY_UID) || "";

  const [profile, setProfile] = useState<UserProfileType>(DEFAULT_USER_PROFILE);
  const [avatar, setAvatar] = useState<string>("");

  const { data } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getUserProfile, uid],
    queryFn: () => UserService.getUser(uid),
    keepPreviousData: true,
  });

  useEffect(() => {
    if (data) {
      setAvatar(data.avatar || "");
      setProfile(currentState => ({
        ...currentState,
        name: data.name,
        email: data.email,
        phoneNumber: data.phoneNumber,
        unit: data.unit || "",
        department: data.department || "",
      }));
    }
  }, [data]);

  return {
    uid,
    profile,
    avatar,
  };
};
